module.exports = __webpack_public_path__ + "media/02 the Mid-Autumn Festival.f0bbd49e.mp3";